export default __webpack_public_path__ + "static/media/13F785E3-F31F-45F2-A2C0-BD66CCDA39CF_1_105_c.2aa5b7a1.jpeg";